<template>
  <div>
    <el-button
      size="medium"
      type="primary"
      icon="el-icon-download"
      :disabled="disabled"
      @click="visible = true"
    >
      <span v-if="showText">Export</span>
    </el-button>
    <ExportExcelPopup
      v-if="visible"
      :title="title"
      :visible="visible"
      :total="total"
      :columns="columns"
      :object-type="objectType"
      :type="type"
      :filter-params="filterParams"
      @close="visible = false"
    />
  </div>
</template>

<script>
import ExportExcelPopup from "@/components/popups/ExportExcel.vue";

export default {
  name: "ExportExcelButton",
  components: {
    ExportExcelPopup,
  },
  props: {
    disabled: Boolean,
    total: Number,
    columns: Array,
    objectType: String,
    type: String,
    title: String,
    filterParams: Object,
    showText: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
